import { render, staticRenderFns } from "./Levels.vue?vue&type=template&id=2aceb116&scoped=true"
import script from "./Levels.vue?vue&type=script&lang=js"
export * from "./Levels.vue?vue&type=script&lang=js"
import style0 from "./Levels.vue?vue&type=style&index=0&id=2aceb116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aceb116",
  null
  
)

export default component.exports